import { render, staticRenderFns } from "./srs-player.vue?vue&type=template&id=8868842c"
import script from "./srs-player.vue?vue&type=script&lang=js"
export * from "./srs-player.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8868842c')) {
      api.createRecord('8868842c', component.options)
    } else {
      api.reload('8868842c', component.options)
    }
    module.hot.accept("./srs-player.vue?vue&type=template&id=8868842c", function () {
      api.rerender('8868842c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/srs-player.vue"
export default component.exports